import * as yup from 'yup';

export const PersonalInfoValidationSchema = yup.object({
	firstName: yup.string().required('auth.validation.enter_name').max(250, 'auth.validation.name_too_long'),
	lastName: yup
		.string()
		.required('auth.validation.enter_last_name')
		.max(250, 'auth.validation.last_name_too_long'),
});
